import { render, staticRenderFns } from "./Easter.vue?vue&type=template&id=5a6d2a96&scoped=true&"
import script from "./Easter.vue?vue&type=script&lang=js&"
export * from "./Easter.vue?vue&type=script&lang=js&"
import style0 from "./Easter.vue?vue&type=style&index=0&id=5a6d2a96&scoped=true&lang=scss&"
import style1 from "./Easter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d2a96",
  null
  
)

export default component.exports